/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progression_Feedback_Hard_HoldInputs */

const en_us2_progression_feedback_hard_hold = /** @type {(inputs: Progression_Feedback_Hard_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two hard sessions in a row: loads hold next time`)
};

const pt_br2_progression_feedback_hard_hold = /** @type {(inputs: Progression_Feedback_Hard_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas sessões pesadas seguidas: as cargas ficam na próxima`)
};

const es_419_progression_feedback_hard_hold = /** @type {(inputs: Progression_Feedback_Hard_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos sesiones pesadas seguidas: los pesos se mantienen la próxima vez`)
};

const pt_pt2_progression_feedback_hard_hold = /** @type {(inputs: Progression_Feedback_Hard_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas sessões pesadas seguidas: as cargas mantêm-se na próxima`)
};

const fr_fr2_progression_feedback_hard_hold = /** @type {(inputs: Progression_Feedback_Hard_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux séances dures : charges maintenues la prochaine fois`)
};

const de_de2_progression_feedback_hard_hold = /** @type {(inputs: Progression_Feedback_Hard_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei harte Einheiten in Folge: Die Gewichte bleiben nächstes Mal gleich`)
};

const it_it2_progression_feedback_hard_hold = /** @type {(inputs: Progression_Feedback_Hard_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due sessioni dure di fila: i carichi restano uguali la prossima volta`)
};

/**
* | output |
* | --- |
* | "Two hard sessions in a row: loads hold next time" |
*
* @param {Progression_Feedback_Hard_HoldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_feedback_hard_hold = /** @type {((inputs?: Progression_Feedback_Hard_HoldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Feedback_Hard_HoldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_feedback_hard_hold(inputs)
	if (locale === "es-419") return es_419_progression_feedback_hard_hold(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_feedback_hard_hold(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_feedback_hard_hold(inputs)
	if (locale === "de-DE") return de_de2_progression_feedback_hard_hold(inputs)
	if (locale === "it-IT") return it_it2_progression_feedback_hard_hold(inputs)
	return en_us2_progression_feedback_hard_hold(inputs)
});
export { progression_feedback_hard_hold as "progression.feedback_hard_hold" }